import React, { useState } from "react";
import Fade from 'react-reveal/Fade'
import '../styles/card.css'
import image from '../styles/face.jpg'

export default function Card() {
    const [noStyle, setNoStyle] = useState({});

    const getRandomPosition = () => {
        const padding = 0;
        const buttonWidth = 120;
        const buttonHeight = 48;
        const maxX = Math.max(window.innerWidth - buttonWidth - padding, padding);
        const maxY = Math.max(window.innerHeight - buttonHeight - padding, padding);
        const left = Math.floor(Math.random() * Math.max(maxX - padding, 0)) + padding;
        const top = Math.floor(Math.random() * Math.max(maxY - padding, 0)) + padding;
        return {
            position: 'fixed',
            left: `${Math.min(left, maxX)}px`,
            top: `${Math.min(top, maxY)}px`,
            zIndex: 1000,
        };
    };

    return(
        <Fade top>
            <div className="mdb-card">
                <img className="project-image" src={image} alt='...' />
                <br />
                <div className="card-body">
                    <p className="card-title">Allison Annie Ly</p>
                    <p className="card-text">Would you like to be my girlfriend?</p>
                    <p>tee hee</p>
                    <a href="/HOORAY"><button type="button" className="link-button">YES</button></a>
                    <button
                        type="button"
                        className="link-button random-button"
                        style={noStyle}
                        onClick={() => setNoStyle(getRandomPosition())}
                    >
                        no booo
                    </button>
                </div>
            </div>
        </Fade>
    )
}